import { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'

import Tags from '../Tags/Tags'

import questionsContext from '../../context/questions'


function List() {
    useEffect(() => document.title = 'Questions', [])

    const questions = useContext(questionsContext)

    const questionComponents = questions.map(question => {
        return <Question key={question.slug} {...question} />
    })

    return <>
        <div className="row-max-1">
            <div>
                <Link to="/questions/new">
                    {/* TODO: Want this btn on right side. */}
                    <button className="btn btn-green">New Question</button>
                </Link>
            </div>

            {questionComponents}
        </div>
    </>
}

function Question({ slug, title, description, tagIds }) {
    return <>
        <div className="box box-sm chapter-item">
            <div className="box-content" style={{ padding: "1em" }}>
                <Link
                    to={'/questions/' + slug}
                    style={{ textDecoration: "none", marginTop: "10px", textAlign: "left", display: "block" }}
                >
                    <h3>{title}</h3>
                    <p className="subtext">{description}</p>
                </Link>

                <Tags tagIds={tagIds} />
            </div>
        </div>
    </>
}

export default List
